import {applyMiddleware} from 'redux';
import thunk from 'redux-thunk';

import {events} from 'src/shared/events/middleware';
import {redirect} from 'src/shared/redirect/middleware';
import {compose} from 'src/shared/utils/compose';
import {screenName} from 'src/pages/reportIssue/store/selectors/screenName';

import {logger} from './logger';
import {channelTracking} from './channelTracking';
import {createDataLayerMiddleware} from 'src/shared/dataLayer/middleware';

export const enhancers = compose(
  applyMiddleware(
    thunk,
    logger,
    channelTracking,
    events,
    createDataLayerMiddleware(screenName),
    redirect
  )
);
